"use strict";
// (C) 2022 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDrillTargetTypeItems = void 0;
var react_intl_1 = require("react-intl");
var types_1 = require("../../../drill/types");
var model_1 = require("../../../../model");
exports.useDrillTargetTypeItems = function () {
    var dropdownItems = [];
    var intl = react_intl_1.useIntl();
    var enableKPIDashboardDrillToDashboard = model_1.useDashboardSelector(model_1.selectEnableKPIDashboardDrillToDashboard);
    var enableKPIDashboardDrillToInsight = model_1.useDashboardSelector(model_1.selectEnableKPIDashboardDrillToInsight);
    var enableKPIDashboardDrillToURL = model_1.useDashboardSelector(model_1.selectEnableKPIDashboardDrillToURL);
    if (enableKPIDashboardDrillToDashboard) {
        dropdownItems.push({
            id: types_1.DRILL_TARGET_TYPE.DRILL_TO_DASHBOARD,
            title: intl.formatMessage({ id: "configurationPanel.drillConfig.drillIntoDashboard" }),
        });
    }
    if (enableKPIDashboardDrillToInsight) {
        dropdownItems.push({
            id: types_1.DRILL_TARGET_TYPE.DRILL_TO_INSIGHT,
            title: intl.formatMessage({ id: "configurationPanel.drillConfig.drillIntoInsight" }),
        });
    }
    if (enableKPIDashboardDrillToURL) {
        dropdownItems.push({
            id: types_1.DRILL_TARGET_TYPE.DRILL_TO_URL,
            title: intl.formatMessage({ id: "configurationPanel.drillConfig.drillIntoUrl" }),
        });
    }
    return dropdownItems;
};
//# sourceMappingURL=useDrillTargetTypeItems.js.map